import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";

FakeTag.propTypes = {
    productId: PropTypes.string
};

function FakeTag({productId}) {
    const eshops = {
        'a': 'Max',
        'b': 'Keren',
        'c': 'Pauline',
        'd': 'Marie',
        'e': 'Clara',
        'f': 'Sabine'
    };

    const firstChar = productId.substring(0, 1)

    if (isNaN(firstChar)) {
        return <Badge rounded backgroundColor={'#f2ebfd'} color={'#7c3bed'}>IA + {eshops[firstChar]}</Badge>
    }

    let num = parseInt(firstChar);

    if (num < 4) {
        return <Badge rounded>IA</Badge>
    } else {
        if (num > 5) {
            num = 5
        }

        return <Badge rounded color={'online'}>{Object.values(eshops)[num]}</Badge>
    }
}

export default FakeTag;
